import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import Index from "container/in-store-pickup/in-store-pickup.container";

function InstorePickup(props: IGenericCmsPage) {
  return <Index {...props} />;
}
export default InstorePickup;
